document.addEventListener('DOMContentLoaded', () => {
  const easySwiperContainer = document.querySelector('.main-line__easy-product .swiper-container')
  const pureSwiperContainer = document.querySelector('.main-line__pure-product .swiper-container')
  if (!easySwiperContainer && !pureSwiperContainer) return

  const easySwiper = new Swiper(easySwiperContainer, {
    loop: false,
    speed: 600,
    slidesPerView: 2.45,
    spaceBetween: 8,
    centeredSlides: false,
    navigation: {
      nextEl: '.main-line__easy-product__controller-next',
      prevEl: '.main-line__easy-product__controller-prev',
    },
    a11y: {
      prevSlideMessage: 'Go to previous slide',
      nextSlideMessage: 'Go to next slide',
      paginationBulletMessage: 'Go to slide {{index}}',
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    },
  })

  const pureSwiper = new Swiper(pureSwiperContainer, {
    loop: false,
    speed: 600,
    slidesPerView: 2.45,
    spaceBetween: 8,
    centeredSlides: false,
    navigation: {
      nextEl: '.main-line__pure-product__controller-next',
      prevEl: '.main-line__pure-product__controller-prev',
    },
    a11y: {
      prevSlideMessage: 'Go to previous slide',
      nextSlideMessage: 'Go to next slide',
      paginationBulletMessage: 'Go to slide {{index}}',
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    },
  })
})
